export default {
    data() {
        return {
            resultFileName   : null,
            fileContent      : null,
            sendSaveError    : null,
            resultTextChanged: false,
        };
    },
    watch: {
        sendSaveError(newValue) {
            if (!!newValue) {
                this.$bvModal.msgBoxOk(this.trans('write/tool-main-write.File Save error text'), {
                    title          : this.trans('write/tool-main-write.File Save error title'),
                    buttonSize     : 'sm',
                    okVariant      : 'primary',
                    okTitle        : this.trans('write/tool-main-write.File Save Cancel btn'),
                    footerClass    : 'p-2',
                    hideHeaderClose: false,
                    centered       : true
                }).then(value => {
                    this.sendSaveError = null;
                    this.completed = true;
                    this.processing = false;
                }).catch(err => {
                    console.log(err)
                });
            }
        },
    },
    // also need auto download mixin
    methods: {
        prepareFileContent() {
            // need override for custom processing
            this.fileContent = this.resultText;
        },

        sendFileContent() {
            if (!this.resultFileName) {
                this.resultFileName = 'tinywow_write_' + this.loaderMode + '_' + this.taskId + '.txt';
            }

            this.completed = false;
            this.processing = true;

            this.prepareFileContent();

            axios({
                method: 'POST',
                url   : '/task/save-result/' + this.taskId,
                data  : {
                    filename: this.resultFileName,
                    content : this.fileContent,
                }
            }).then((response) => {
                if (response.data.status) {
                    let downloadUrl = response.data.download_url;
                    if (downloadUrl) {
                        this.downloadUrl = downloadUrl;
                        this.downloadFileInfo.name = downloadUrl.replace(/^.*[\\\/]/, '');
                        this.dropboxFiles = [
                            {
                                'url'     : downloadUrl,
                                'filename': downloadUrl.replace(/^.*[\\\/]/, ''),
                            }
                        ];

                        this.autoDownloadFile();
                    }

                    this.completed = true;
                    this.processing = false;
                    this.sendSaveError = null;
                    this.resultTextChanged = false;
                } else {
                    this.completed = false;
                    this.processing = false;
                    this.sendSaveError = this.trans('write/tool-main-write.File Save error text');
                }
            }).catch(() => {
                this.completed = false;
                this.processing = false;
                this.sendSaveError = this.trans('write/tool-main-write.File Save error text');
            })
        },

        onChangeResultText(changed) {
            this.resultTextChanged = changed !== 'undefined' ? !!changed : true;
        },
        onChangePromptText(changed) {

        },
    }
}
